import { log } from './log';
import { getPageUrl } from '../shorts/utils';

export const hasQueryStringVar = (queryStringVar: string) => {
  const params = new URLSearchParams(window?.location?.search);
  return params.has(queryStringVar);
};

export const withinDeliveryCap = (deliveryCap: number) => {
  if (!deliveryCap) {
    return true;
  }
  const randomNumber = Math.random();
  return randomNumber <= deliveryCap;
};

export const getViewportWidth = () => {
  return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};

export const hasContextualVideo = (playlist: any[]): boolean => {
  return playlist[0]?.contextual;
};

export const extractContextualVideoFromPlaylist = (playlist: any[]): any[] => {
  if (playlist[0]?.contextual) {
    return [playlist[0]];
  }
  return [];
};

export const getVerticalPlaylist = async (pixelsPageId: string, publisherId: string, section: string) => {
  if (hasQueryStringVar('has_vertical_match')) {
    log('pixels', 'injecting vertical test match...');

    // sample vertical football
    return [
      {
        headline: 'A football clip',
        animated_preview: 'https://image.mux.com/00fUen6dcSMyJ4mQketBbgHvJu0013S3EVIaviSw4hxws/animated.gif?width=90',
        thumbnail:
          'https://image.mux.com/00fUen6dcSMyJ4mQketBbgHvJu0013S3EVIaviSw4hxws/thumbnail.png?width=360&height=640&time=0',
        media_id: '00fUen6dcSMyJ4mQketBbgHvJu0013S3EVIaviSw4hxws',
        format: 'vertical',
        duration: 32,
        rightsholder: 'pixels',
        contextual: true,
      },
    ];
  }
  const endpoint = new URL(__MATCH_VIDEO_ENDPOINT__);
  endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + `/vertical/${publisherId}/${section}/${pixelsPageId}`;
  endpoint.searchParams.append('url', getPageUrl());
  log('pixels', 'endpoint', endpoint.toString());
  return await (await fetch(endpoint.toString())).json();
};
